export default "__VITE_ASSET__BIQQIajj__"